import { Component } from "react";
import './SolicitacaoCadastroArquivosGrandesVolumes.css';
import { SecureDirectoryClientInformationDetail } from "../SecureDirectory/SecureDirectoryClientInformationDetail";

export const ArquivoGrandesVolumesDetails =

class extends Component {

	render() {
		return (
			<div>
				{this.renderForm()}
			</div>
		);
	}

	renderForm() {
		const { solicitacao, mostraDetalhesPastaSegura } = this.props;

		return(
			<div className="container-fluid">
				<div className="br-form">
					<div className="row">
						{ solicitacao.id &&
							<div className="col-6">
								<div className="field">
									<div className="input">
										<label htmlFor="numero">Número:</label>
										<input type="text" name="numero"
											value={solicitacao.numero}  
											disabled
											/>
									</div>
								</div>
							</div>
						}
						{ solicitacao.id &&
                            <div className="col-6">
									<div className="field">
										<div className="input">
											<label htmlFor="nomeSituacao">Situação:</label>
											<input type="text" name="nomeSituacao"
												value={solicitacao.nomeSituacao}  
												disabled
												/>
										</div>
									</div>
								</div>
						}
                    </div>
					<div className="row">
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label htmlFor="cedenteDosDados">Cedente dos Dados:</label>
									<input type="text" name="cedenteDosDados" maxLength="14"
										value={solicitacao.nomeOrgao}  
										readOnly
										/>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label htmlFor="esferasAdministrativas">Disponível para órgãos das esferas administrativas:</label>						
									<input type="text" name="esferasAdministrativasDisponiveis" maxLength="14"
										value={solicitacao.esferasAdministrativas.map(e => e.nome).join(', ')}  
										readOnly
										/>	
								</div>
							</div>
						</div>
					</div>
					<div className="row">	
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label>Dirigente de TI:</label>
									<input type="text" name="cpfDirigenteTi" maxLength="14"
										value={solicitacao.nomeDirigenteTi}  
										readOnly
										/>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label>Responsável Técnico:</label>
									<input type="text" name="cpfResponsavelTecnico" maxLength="14"
										value={solicitacao.nomeResponsavelTecnico}  
										readOnly
										/>
								</div>
							</div>
						</div>
					</div>
					<div className="row text-center">
						<div className="col-6">
							<div className="field">
								<div className="input">
									<div className="d-flex">
										<label htmlFor="titulo">Título do conjunto de arquivo:</label>
									</div>
									<input type="text" name="titulo" maxLength="100"
										value={solicitacao.titulo}  
										onChange={this.handleInputChange}
										readOnly
									/>
								</div>
							</div>
						</div>
						<div className="col-6">
							<div className="field">
								<div className="input">
									<div className="d-flex">
										<label htmlFor="ativo">Ativo:</label>
									</div>
									<input type="text" name="ativo" maxLength="100"
										value={solicitacao.ativo ? "Ativo" : "Inativo"}  
										onChange={this.handleInputChange}
										readOnly
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="field">
								<div className="input">
									<label htmlFor="descricao">Descrição do conjunto de arquivo:</label>
									<textarea name="descricao" maxLength="500" rows="4"
										value={solicitacao.descricao}  
										readOnly
									/>
								</div>
							</div>
						</div>
					</div>

					<div className="mt-4 mb-4">
						<h2 ref={this.arquivosRef}>Arquivos</h2>
					</div>
					<fieldset className="mb-4">
						{(solicitacao.arquivos && solicitacao.arquivos.length > 0) &&	
						<div className="br-table">						
							<div className="table">
								<table>
									<thead>
										<tr>
											<th scope="col">Nome</th>
											<th scope="col">Descrição</th>
											<th scope="col">Extensão</th>
											<th scope="col">Tamanho em MB (Megabytes)</th>
											<th scope="col">Periodicidade</th>
											<th className="text-center" scope="col"style={{width: "5%"}}>Ativo</th>
											
										</tr>
									</thead>
									
									<tbody>
										{ solicitacao.arquivos.map((arq, index) =>
												<tr key={index} >
													<td>{arq.nome}</td>
													<td>{arq.descricao}</td>
													<td>{arq.nomeExtensaoArquivo}</td>
													<td>{arq.tamanho}</td>
													<td>{arq.nomePeriodicidade}</td>
													<td className="text-center">
														<div className="actions">
															<input 
																type="checkbox" 
																checked={arq.ativo !== false}
																readOnly
															/>
														</div>
													</td>
												</tr>
											)}
									</tbody>
								</table>
							</div>
						</div>
						}
						{(!solicitacao.arquivos || solicitacao.arquivos.length === 0) &&
							<div>
								Nenhum arquivo cadastrado para a solicitação de grandes volumes.
							</div>
						}
					</fieldset>

					{ mostraDetalhesPastaSegura &&
						<SecureDirectoryClientInformationDetail solicitacao={solicitacao} />
					}

				</div>				
			</div>
		);	
	}

}
